import React, { FC, useEffect, useState } from 'react'

import { ModalProps } from '@Components/Modal'

import { LoginModal } from './LoginModal'
import { ResetPasswordModal } from './ResetPasswordModal'

export enum FormStates {
  None,
  Loading,
  Failed,
  Success,
}

interface LoginModalsProps extends ModalProps {
  sourceID: string
}

export const LoginModals: FC<LoginModalsProps> = (props: LoginModalsProps) => {
  const [isResetPassword, setIsResetPassword] = useState(false)
  const [hasBeenShown, setHasBeenShown] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react/destructuring-assignment
    if (props.isOpen && !hasBeenShown) {
      setHasBeenShown(true)
    }
    // eslint-disable-next-line react/destructuring-assignment
  }, [props.isOpen, hasBeenShown])

  // eslint-disable-next-line react/destructuring-assignment
  if (!hasBeenShown && !props.isOpen) {
    return null
  }

  if (isResetPassword) {
    return <ResetPasswordModal handleBackToLogin={() => setIsResetPassword(false)} {...props} />
  }
  return <LoginModal handleResetPassword={() => setIsResetPassword(true)} {...props} />
}
